var useSyncExternalStoreShim_production = {};
export {
  useSyncExternalStoreShim_production as __exports
};
//# sourceMappingURL=use-sync-external-store-shim.production.js.map
